"use client";
import "./treatmentPackagesCarousel.scss";
import TreatmentPackageCard from "./TreatmentPackageCard/TreatmentPackageCard";
import CustomCarousel from "@/components/CustomCarousel/CustomCarousel.js";
import Link from "next/link";
import {
  fetchTreatmentPackages,
  selectAllTreatmentPackages,
  selectAllTreatmentPackagesStatus,
} from "@/slice/treatmentPackageSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import FullScreenLoader from "../FullScreenLoader/FullScreenLoader";

export default function TreatmentPackages({ itemsPerPage = 6, data }) {
  const dispatch = useDispatch();
  const selectAllTreatmentPackagesData = useSelector(
    selectAllTreatmentPackages,
  );
  const treatmentPackage = data || selectAllTreatmentPackagesData;
  const selectAllTreatmentPackagesStatusInfo = useSelector(
    selectAllTreatmentPackagesStatus,
  );
  const intl = useIntl();
  const lang = useSelector((state) => state.locale.locale);

  useEffect(() => {
    if (!data) {
      dispatch(fetchTreatmentPackages({ locale: lang }));
    }
  }, [lang, data, dispatch]);

  const packages = Array.isArray(treatmentPackage)
  ? treatmentPackage
  : treatmentPackage?.treatment_packages || treatmentPackage?.data || [];

  return (
    <>
      <div className="treatmentPackageWrapper">
        <h1 className="p-0 m-0 ">
          <p className="treatmentPackageHeading">
            {intl.formatMessage({ id: "sponsoredTop" })}{" "}
            <span className="bold">
              {intl.formatMessage({
                id: "treatmentPackageHeading",
              })}
            </span>
          </p>
        </h1>
        {packages.length > 0 && (
          <CustomCarousel
            itemsPerPage={itemsPerPage}
            previousButtonClassName="xl:-left-[32px] lg:-left-[24px] -left-[2px] top-[35%] translate-x-1/2"
            nextButtonClassName="xl:right-[2px] lg:-right-[14px] -right-[2px] top-[35%] translate-x-1/2"
          >
            {packages.map((packageDetails, i) => (
              <TreatmentPackageCard
                key={packageDetails.id || i}
                packageDetails={{
                  ...packageDetails,
                  attributes: {
                    ...packageDetails,
                    img: packageDetails.img || null,
                  },
                }}
              />
            ))}
          </CustomCarousel>
        )}
        <Link href="/packages">
          <button className="viewAllBtn">
            {intl.formatMessage({ id: "viewAllBtn" })}
          </button>
        </Link>
        <FullScreenLoader
          isLoading={selectAllTreatmentPackagesStatusInfo === "loading"}
        />
      </div>
    </>
  );
}
